import { render, staticRenderFns } from "./IndustryTrend.vue?vue&type=template&id=2ac0b486&scoped=true"
import script from "./IndustryTrend.vue?vue&type=script&lang=js"
export * from "./IndustryTrend.vue?vue&type=script&lang=js"
import style0 from "./IndustryTrend.vue?vue&type=style&index=0&id=2ac0b486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0b486",
  null
  
)

export default component.exports